module.exports = __webpack_public_path__ + "img/slide4.f5c9e06b.png";